export interface IUserReference {
	readonly name: string;
	readonly endDate: Date;
	readonly startDate: Date;
	readonly institution: string;
	readonly summary: string;
	readonly id: string;
}

export class UserReference implements IUserReference {
	private _name: string;
	private _endDate: Date;
	private _startDate: Date;
	private _institution: string;
	private _summary: string;
	private _id: string;

	constructor(
		id: string,
		name: string,
		endDate: Date,
		startDate: Date,
		institution: string
	) {
		this._name = name;
		this._endDate = endDate;
		this._startDate = startDate;
		this._institution = institution;
		this._summary = `${name}, ${institution}`;
		this._id = id;
	}

	public get id(): string {
		return this._id;
	}

	public get name(): string {
		return this._name;
	}

	public get endDate(): Date {
		return this._endDate;
	}

	public get startDate(): Date {
		return this._startDate;
	}

	public get institution(): string {
		return this._institution;
	}

	public get summary(): string {
		return this._summary;
	}
}
